import styled from "styled-components";

interface StyledDialogBodyProps {
  $size: "large" | "medium" | "small";
  $state: "info" | "success" | "warning" | "error";
  $flexFlow: "column nowrap" | "row nowrap";
}

export const StyledDialogBody = styled.div<StyledDialogBodyProps>`
  display: flex;
  flex-flow: ${({ $flexFlow }) => $flexFlow};
  gap: 0.8rem;
  font: var(--body-large-400);
  color: ${({ $state }) =>
    $state === "info"
      ? "var(--text-gray-strong)"
      : $state === "success"
      ? "var(--pri-blue-5)"
      : $state === "warning"
      ? "var(--sec-orange-5)"
      : "var(--sys-red-0)"};
  .status-icon {
    display: flex;
    align-items: center;
    height: 2.4rem;
  }
  .pre-wrap {
    white-space: pre-wrap;
    word-break: break-all;
  }
  b {
    font: var(--body-large-600);
  }
`;
